/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-price-policies';

export const EntityPricePolicyApi = {
  findForSelect: async (option: FindEntityPricePolicyForSelectQuery) => {
    let url = `${pathname}/select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForMenuShareSelect: async (option: any) => {
    let url = `${pathname}/menu-share/select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForSelectForCreateBillFromOrder: async (option: any) => {
    let url = `${pathname}/create-bill-from-order/select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForSelectInChain: async (option: FindEntityPricePolicyForSelectQuery) => {
    let url = `${pathname}/select-in-chain`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: FindOptions) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneWithEntity: async (id: string) => {
    const url = `${pathname}/find-one-with-entity/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityProductForInherit: async (id: string) => {
    const url = `${pathname}/find-entity-product-for-inherit/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityProductForDuplicate: async (id: string) => {
    const url = `${pathname}/find-entity-product-for-duplicate/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInheritEntityPricePolicy: async (
    option: FindEntityPricePolicyForInheritQuery
  ) => {
    let url = `${pathname}/find-inherit-entity-price-policy`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForInherit: async (option: FindEntityPricePolicyForInheritQuery) => {
    let url = `${pathname}/find-for-inherit`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForDuplicate: async (option: FindEntityPricePolicyForInheritQuery) => {
    let url = `${pathname}/find-for-duplicate`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    const url = pathname;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (options: CheckDuplicateEntityPricePolicyQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  duplicate: async (id: string, body: DuplicateEntityPricePolicyBody) => {
    const url = `${pathname}/duplicate/${id}`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findApplyEntityInEntityPricePolicy: async (id: string) => {
    const url = `${pathname}/apply-entities/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateEntityPricePolicyBody {
  name?: string;
  isPublic?: boolean;
  isDefault?: boolean;
  code?: string;
  settings?: {
    import?: {
      updatedAt?: string;
      importedAt?: string;
    };
  };
}

export interface FindEntityPricePolicyForSelectQuery {
  entityID?: string;
}

export interface FindEntityPricePolicyForInheritQuery {
  name?: string;
  entityID?: string;
  entityPricePolicyID?: string;
}

export type EntityPricePolicy = {
  id: string;
  name: string;
  code: string;
  entityID: string;
  isPublic?: boolean;
  isDefault?: boolean;
  totalMember?: number;
  rating?: number;
  status?: number;
  createdAt?: string;
  updatedAt?: string;
  pricePolicy?: any;
  partners?: any[];
  invitations?: any[];
};

export interface DuplicateEntityPricePolicyBody {
  name: string;
  chainEntityIDs?: string[];
}

export interface CheckDuplicateEntityPricePolicyQuery {
  code: string;
  entityID: string;
}
